export class FooterMenu{
    ACTIVE_CLASS = 'active';
    menuItemEl = '.js-footer-menu-item';
    subMenuEl = '.js-footer-menu-submenu'

    onClickItem = (e) => {
        const clickedEl = $(e.currentTarget);

        clickedEl.hasClass('active') ? this.closeSubMenu(clickedEl) : this.openSubMenu(clickedEl);
    }

    openSubMenu = (el) => {
        this.menuItem.removeClass(this.ACTIVE_CLASS);
        this.submenu.slideUp(300);
        const submenu = el.next();
        el.addClass(this.ACTIVE_CLASS);
        submenu.slideDown(300);
    }

    closeSubMenu = (el) => {
        const submenu = el.next();
        el.removeClass(this.ACTIVE_CLASS);
        submenu.slideUp(300);
    }

    init = () => {
        this.menuItem.on('click', this.onClickItem);
    }

    destruct = () => {
        this.menuItem.off('click', this.onClickItem);
        this.submenu.slideDown();
        this.menuItem.removeClass('active');
    }

    constructor(node) {
        this.node = $(node);
        this.menuItem = $(this.menuItemEl);
        this.submenu = $(this.subMenuEl);
    }
}



// WEBPACK FOOTER //
// ./app/blocks/footer-menu/footer-menu.js